module.exports = __webpack_public_path__ + "img/17.1095ddf1.jpg";